import React, { HTMLProps, ReactElement, useEffect, useRef, useState } from 'react'
import { Color } from '../utils/constants'
import { twMerge } from 'tailwind-merge'

interface MouseGradientBlockAltProps extends HTMLProps<HTMLDivElement> {
  children: ReactElement
}

const MouseGradientBlockAlt = ({ children, className, ...props }: MouseGradientBlockAltProps) => {
    const [isHovered, setIsHovered] = useState(false)
    const ref = useRef<HTMLDivElement>(null)
    const mouseMove = (e: MouseEvent) => {
        if (ref.current) {
            // @ts-ignore
            const rect = ref.current.getBoundingClientRect()
            const windowWidth = ref.current.clientWidth
            const windowHeight = ref.current.clientHeight

            const mouseXpercentage = Math.round(((e.clientX - rect.left) / windowWidth) * 100)
            const mouseYpercentage = Math.round(((e.clientY - rect.top) / windowHeight) * 100)
            ref.current.style.background = `radial-gradient(farthest-side at ${mouseXpercentage}% ${mouseYpercentage}%, ${Color.GREEN_LIGHT}, ${Color.TRANSPARENT})`
        }
    }
    useEffect(() => {
        const current = ref.current
        if (isHovered && current) {
            const handleMouseMove = (e: MouseEvent) => {
                setTimeout(() => mouseMove(e), 0)
            }
            current.addEventListener('mousemove', handleMouseMove)
            return () => {
        current?.removeEventListener('mousemove', handleMouseMove)
            }
        } else if (current) {
            ref.current.style.background = Color.TRANSPARENT
        }
    }, [isHovered, ref])
    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            ref={ref}
            className={twMerge('', className)}
            {...props}
        >
            {children}
        </div>
    )
}

export default MouseGradientBlockAlt
